// extracted by mini-css-extract-plugin
export default {"score":"score__sDB26V","alert":"alert__Xn9tvv"};